<template>
    <Dialog v-model="show" @input="$listeners.input" :title="title" width="450" :show-close-button="showCloseButton">
        <v-form ref="form" @submit.prevent="confirm">
            <DynamicSelectPaginated ref="pontoVendaSelect"
                           label="Ponto de venda:"
                           id="PontoVendaSelect"
                           v-model="ponto_venda"
                           placeholder="Selecione o ponto de venda"
                           endpoint="/dynamic-selects/hierarquia_comercial/pontos_venda_paginados"
                           :multiple="false"
                           :rules="[$rules.required]"
                           :return-object="true"
                           :params="params"
                           item-text="nomeExibicaoPontoVenda"
                           :key="autoCompleteKey"
                           :enablePagination="true"
                           @menu-opened="onMenuOpened"
            />
            <div class="d-flex justify-center mt-4">
                <v-btn class="transition" color="primary" rounded @click="showConfirmation">
                    Confirmar
                </v-btn>
            </div>
            <v-form />
        </v-form>
    </Dialog>
</template>

<script>
  import { CommercialHierarchyTypes } from '@/plugins/constants'
  import commercialHierarchy from '@/mixins/commercialHierarchy'
  export default {
    name: 'DialogSalesPointHierarchy',
    mixins: [commercialHierarchy],
    props: {
      value: { type: Boolean, default: true },
      gerenteNegocio: String,
      estruturaSelecionada: [String, Number],
      showCloseButton: { type: Boolean, default: true },
      isEntrandoFluxoVenda: { type: Boolean, default: false }
    },
    data: () => ({
      title: 'SELECIONE O PONTO DE VENDA',
      ponto_venda: null,
      autoCompleteKey: 0
    }),
    computed: {
      show: {
        get () {
          return this.value
        },
        set (val) {
          if (!val) {
            this.isEntrandoFluxoVendaComputed = false
          }
          this.$emit('input', val)
        }
      },
      params () {
        return {
          gerenteNegocio: this.gerenteNegocio,
          idEstruturaSelecionada: this.estruturaSelecionada || 0,
          isEntrandoFluxoVendas: this.isEntrandoFluxoVendaComputed
        }
      },
      isEntrandoFluxoVendaComputed: {
        get () {
          return this.isEntrandoFluxoVenda
        },
        set (val) {
          this.$emit('setarEntrandoFluxoVenda', val)
        }
      }
    },
    watch: {
      value (newValue, oldValue) {
        if (newValue && !oldValue) {
          this.ponto_venda = null
          this.autoCompleteKey++
        }
      }
    },
    mounted () {
      // lifecycle hook se precisar
    },
    methods: {
      onMenuOpened () {
        this.$nextTick(() => {
          const scrollElement = this.$refs.pontoVendaSelect.getScrollableElement()
          if (scrollElement) {
            scrollElement.addEventListener('scroll', (e) => {
              const { scrollTop, clientHeight, scrollHeight } = e.target
              const scrollRestante = scrollHeight - (scrollTop + clientHeight)
              const metadeScroll = scrollHeight * 0.5
              if (scrollRestante <= metadeScroll) {
                this.$refs.pontoVendaSelect.loadNextPage()
              }
            })
          }
        })
      },
      showConfirmation () {
        this.isUsuarioFluxoVendas(true, this.confirm, this.isEntrandoFluxoVendaComputed)
      },
      fecharDialog () {
        if (this.isEntrandoFluxoVendaComputed) {
          this.$emit('voltarFluxoVenda')
        } else {
          this.$router.replace({ path: '/', query: { redirecionamentoPainelLateral: true } })
        }
        this.$emit('input', false)
      },
      confirm () {
        const form = this.$refs.form
        if (this.ponto_venda?.nomeExibicaoPontoVenda.toString().toLowerCase() === CommercialHierarchyTypes.Todos.text.toLowerCase()) {
          this.resetarPontoDeVenda()
          this.fecharDialog()
        } else if (form.validate()) {
          const comissionados = this.ponto_venda['comissionados'] || []

          this.$session.set('id_ponto_venda', this.ponto_venda['idPontoVenda'])
          this.$session.set('cd_ponto_venda', this.ponto_venda['codigoPontoVenda'])
          this.$session.set('nm_ponto_venda', this.ponto_venda['nomePontoVenda'])
          this.$session.set('data_inicio_vigencia', this.ponto_venda['dataInicioVigencia'])
          this.$session.set('data_fim_vigencia', this.ponto_venda['dataFimVigencia'])

          this.$session.set('comissionados', comissionados)

          const idComissionados = comissionados.map(c => c.idComissionado)
          const todosMesmosIds = idComissionados.length > 0 && idComissionados.every(id => id === idComissionados[0])

          if (todosMesmosIds) {
            this.$session.set('id_comissionado_venda', idComissionados[0])
          } else {
            this.$session.set('id_comissionado_venda', -1)
          }
          this.$emit('pontoVendaConfirmado', this.ponto_venda)
          this.fecharDialog()
        }
      }
    }
  }
</script>

<style scoped>

</style>
